export const CLEANSE_FILL_EXTRACT_SCHEMA_NAME = 'cleanse_fill_extract';

export const getCheckpointListDirectoriesUrl = () => {
    const datasetBucket = `spins-edp-${process.env.REACT_APP_ENV}-checkpoint`;
    return `${process.env.REACT_APP_EDP_API_BASE_URL}/listDirectories/?bucket=${datasetBucket}&subdirectory=p_dataset=cleanse_fill_extract/`;
};

export const getDefaultPeriodCheckpointsUrl = () => `${process.env.REACT_APP_EDP_API_BASE_URL}/defaultPeriodCheckPoints/`;

export function buildCleanseFillExtractCheckpointOptions(directoryNames) {
    return (directoryNames || [])
        .filter(tableName => tableName.includes('_final'))
        .sort((runIdentifier1, runIdentifier2) => {
            const aTimestamp = runIdentifier1.match(/\d{4}_\d{2}_\d{2}t[\d_]+/)?.[0] ?? '';
            const bTimestamp = runIdentifier2.match(/\d{4}_\d{2}_\d{2}t[\d_]+/)?.[0] ?? '';
            return bTimestamp.localeCompare(aTimestamp);
        })
        .map(tableName => {
            const checkpointName = tableName.replaceAll('_cleanse_fill_extract', '').replaceAll('p_run_id=', '');
            return {value: checkpointName, label: checkpointName};
        });
}

export const getLatestCheckpointRunIdentifier = options => options[0]?.value;

export function resolveCheckpointRunIdentifierForSubmit(selectedCheckpoint, periodCheckpointMap, checkpointOptions) {
    if (selectedCheckpoint) {
        return selectedCheckpoint;
    }
    return getMostRecentRegistryCheckpoint(periodCheckpointMap) ?? getLatestCheckpointRunIdentifier(checkpointOptions);
}

export function buildPeriodCheckpointMap(serviceFileData) {
    const rows = serviceFileData?.data ?? [];
    return Object.fromEntries(rows.map(row => [row.periodAbbreviation, row.checkpoint]));
}

export function getMostRecentRegistryCheckpoint(periodCheckpointMap) {
    const periods = Object.keys(periodCheckpointMap || {});
    if (periods.length === 0) {
        return undefined;
    }
    const mostRecentPeriod = periods.sort().at(-1);
    return periodCheckpointMap[mostRecentPeriod];
}

export function resolveDefaultCheckpointForPeriod(period, periodCheckpointMap, checkpointOptions) {
    const mappedCheckpoint = (periodCheckpointMap || {})[period];
    if (mappedCheckpoint) {
        return mappedCheckpoint;
    }
    return getMostRecentRegistryCheckpoint(periodCheckpointMap) ?? getLatestCheckpointRunIdentifier(checkpointOptions);
}
